var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Nonberusaha',{attrs:{"tipe_pemohon":'Swasta'}})
}
var staticRenderFns = []

export { render, staticRenderFns }